
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexS31H_Pr8wusWUDaMGNKWQO3KFE6whej2oyrb4vtxbmoMeta } from "C:/Users/Nabil/Desktop/find_app/pages/about/index.vue?macro=true";
import { default as index9VO_JLs_dyYgAYhfbbsxH0xnp0jLhBTeXnnpFh5yv1YMeta } from "C:/Users/Nabil/Desktop/find_app/pages/contact-us/index.vue?macro=true";
import { default as index_45ebzwMsOf1vqOIC2Cy45pjXDGb6zCwyRz4N2Nd3hQogMeta } from "C:/Users/Nabil/Desktop/find_app/pages/index.vue?macro=true";
import { default as indexdg18yEnDPAlfukir0_451andUCnNcKyE0h61hULZ8g4pAMeta } from "C:/Users/Nabil/Desktop/find_app/pages/item/create/index.vue?macro=true";
import { default as indexn2uU2BqbXbP5zTw5KbQM2DfOndS1deFs2ZP4RtHERRQMeta } from "C:/Users/Nabil/Desktop/find_app/pages/item/show/index.vue?macro=true";
import { default as indexkXwR2SZMJivZIsEx03udcutyffgAZ41vitifiCgJpd8Meta } from "C:/Users/Nabil/Desktop/find_app/pages/store/index.vue?macro=true";
import { default as indexuvEvzVt1d90BJWirswRF19ewrUDq5IVP1VwEObr0mw0Meta } from "C:/Users/Nabil/Desktop/find_app/pages/success-opertations/index.vue?macro=true";
import { default as indexz3_453cci4pXxMtWUdHOC6EB6tXyuMnDWiwMtisAo_MZAMeta } from "C:/Users/Nabil/Desktop/find_app/pages/terms-and-conditions/index.vue?macro=true";
import { default as _91id_93hFI1xvuZsTv_sO6tvXPw_drHWRo7phEVrvkw04NNkQYMeta } from "C:/Users/Nabil/Desktop/find_app/pages/user/change-password/[id].vue?macro=true";
import { default as _91id_93cFzENW77BAw4rj7MegFtt1GjRo8fZ6xHeVrqWJbBBh0Meta } from "C:/Users/Nabil/Desktop/find_app/pages/user/lost-something/[id].vue?macro=true";
import { default as _91id_93KaTEP4_45xGYZPlhfgKVg4QzlSpSvEpCWEvV0z5sTR_gcMeta } from "C:/Users/Nabil/Desktop/find_app/pages/user/profile/[id].vue?macro=true";
export default [
  {
    name: "about___en",
    path: "/en/about",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/about/index.vue")
  },
  {
    name: "about___ar",
    path: "/about",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/about/index.vue")
  },
  {
    name: "contact-us___en",
    path: "/en/contact-us",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/contact-us/index.vue")
  },
  {
    name: "contact-us___ar",
    path: "/contact-us",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/contact-us/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/index.vue")
  },
  {
    name: "index___ar",
    path: "/",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/index.vue")
  },
  {
    name: "item-create___en",
    path: "/en/item/create",
    meta: indexdg18yEnDPAlfukir0_451andUCnNcKyE0h61hULZ8g4pAMeta || {},
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/item/create/index.vue")
  },
  {
    name: "item-create___ar",
    path: "/item/create",
    meta: indexdg18yEnDPAlfukir0_451andUCnNcKyE0h61hULZ8g4pAMeta || {},
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/item/create/index.vue")
  },
  {
    name: "item-show___en",
    path: "/en/item/show",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/item/show/index.vue")
  },
  {
    name: "item-show___ar",
    path: "/item/show",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/item/show/index.vue")
  },
  {
    name: "store___en",
    path: "/en/store",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/store/index.vue")
  },
  {
    name: "store___ar",
    path: "/store",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/store/index.vue")
  },
  {
    name: "success-opertations___en",
    path: "/en/success-opertations",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/success-opertations/index.vue")
  },
  {
    name: "success-opertations___ar",
    path: "/success-opertations",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/success-opertations/index.vue")
  },
  {
    name: "terms-and-conditions___en",
    path: "/en/terms-and-conditions",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/terms-and-conditions/index.vue")
  },
  {
    name: "terms-and-conditions___ar",
    path: "/terms-and-conditions",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/terms-and-conditions/index.vue")
  },
  {
    name: "user-change-password-id___en",
    path: "/en/user/change-password/:id()",
    meta: _91id_93hFI1xvuZsTv_sO6tvXPw_drHWRo7phEVrvkw04NNkQYMeta || {},
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/user/change-password/[id].vue")
  },
  {
    name: "user-change-password-id___ar",
    path: "/user/change-password/:id()",
    meta: _91id_93hFI1xvuZsTv_sO6tvXPw_drHWRo7phEVrvkw04NNkQYMeta || {},
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/user/change-password/[id].vue")
  },
  {
    name: "user-lost-something-id___en",
    path: "/en/user/lost-something/:id()",
    meta: _91id_93cFzENW77BAw4rj7MegFtt1GjRo8fZ6xHeVrqWJbBBh0Meta || {},
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/user/lost-something/[id].vue")
  },
  {
    name: "user-lost-something-id___ar",
    path: "/user/lost-something/:id()",
    meta: _91id_93cFzENW77BAw4rj7MegFtt1GjRo8fZ6xHeVrqWJbBBh0Meta || {},
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/user/lost-something/[id].vue")
  },
  {
    name: "user-profile-id___en",
    path: "/en/user/profile/:id()",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/user/profile/[id].vue")
  },
  {
    name: "user-profile-id___ar",
    path: "/user/profile/:id()",
    component: () => import("C:/Users/Nabil/Desktop/find_app/pages/user/profile/[id].vue")
  }
]